import { useEffect, useState } from "react";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser, fmt } from "../../lib/api";

export default function Transactions() {
  const user = readUser();
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("All");
  useEffect(() => { api.get("/transactions").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const types = ["All", "Mining Reward", "Daily Production", "Referral", "Withdrawal", "Adjustment"];
  const filtered = rows.filter((r) => filter === "All" ? true : (filter === "Referral" ? r.type.startsWith("Referral") : r.type.includes(filter)));
  return (
    <MemberLayout user={user} active="Transactions">
      <div className="table-panel">
        <div className="panel-heading">
          <div><span className="eyebrow">LEDGER</span><h3>All transactions</h3></div>
          <div className="filter-pills">
            {types.map((t) => <button key={t} className={filter === t ? "pill active" : "pill"} onClick={() => setFilter(t)} data-testid={`filter-${t.toLowerCase().replace(" ", "-")}`}>{t}</button>)}
          </div>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Date</th><th>Type</th><th>Amount</th><th>Before</th><th>After</th><th>Reference</th><th>Status</th></tr></thead>
            <tbody>
              {filtered.map((t, i) => (
                <tr key={i} data-testid={`tx-row-${i}`}>
                  <td>{new Date(t.date).toLocaleString()}</td>
                  <td>{t.type}</td>
                  <td className={t.amount < 0 ? "neg" : "pos"}>${fmt(t.amount, t.type === "Mining Reward" ? 3 : 2)}</td>
                  <td>${fmt(t.balance_before, t.type === "Mining Reward" ? 3 : 2)}</td>
                  <td>${fmt(t.balance_after, t.type === "Mining Reward" ? 3 : 2)}</td>
                  <td className="hash">{(t.reference || "").slice(0, 14)}</td>
                  <td><span className={`status ${t.status.toLowerCase()}`}>{t.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          {!filtered.length && <div className="table-empty">No transactions yet.</div>}
        </div>
      </div>
    </MemberLayout>
  );
}
